// src/components/icon/icon.types.ts
var FAIcon = /* @__PURE__ */ ((FAIcon2) => {
  FAIcon2["Info"] = "info";
  FAIcon2["Warn"] = "warning";
  FAIcon2["Error"] = "error";
  FAIcon2["Check"] = "check";
  FAIcon2["Close"] = "close";
  FAIcon2["Dollar"] = "dollar";
  FAIcon2["Settings"] = "settings";
  FAIcon2["Refresh"] = "refresh";
  FAIcon2["Caret"] = "caret";
  FAIcon2["Chevron"] = "chevron";
  FAIcon2["Add"] = "add";
  FAIcon2["Heart"] = "heart";
  FAIcon2["Book"] = "book";
  FAIcon2["House"] = "house";
  FAIcon2["Search"] = "search";
  FAIcon2["User"] = "user";
  FAIcon2["Bank"] = "bank";
  FAIcon2["Envelope"] = "envelope";
  FAIcon2["File"] = "file";
  FAIcon2["Leaf"] = "leaf";
  FAIcon2["Phone"] = "phone";
  FAIcon2["Link"] = "link";
  FAIcon2["UpArrow"] = "up-arrow";
  FAIcon2["DownArrow"] = "down-arrow";
  FAIcon2["Clone"] = "clone";
  FAIcon2["Exclamation"] = "exclamation";
  return FAIcon2;
})(FAIcon || {});
var LobIcon = /* @__PURE__ */ ((LobIcon2) => {
  LobIcon2["Bonds"] = "bonds";
  LobIcon2["BOP"] = "bop";
  LobIcon2["CommercialAuto"] = "commercial-auto";
  LobIcon2["CPP"] = "cpp";
  LobIcon2["DwellingFire"] = "dwelling-fire";
  LobIcon2["ExecutiveUmbrella"] = "executive-umbrella";
  LobIcon2["Farm"] = "farm";
  LobIcon2["FarmUmbrella"] = "farm-umbrella";
  LobIcon2["Flood"] = "flood";
  LobIcon2["Garage"] = "garage";
  LobIcon2["Home"] = "home";
  LobIcon2["InlandMarine"] = "inland-marine";
  LobIcon2["Life"] = "life";
  LobIcon2["MobileHome"] = "mobile-home";
  LobIcon2["PersonalAuto"] = "personal-auto";
  LobIcon2["RecreationalVehicle"] = "recreational-vehicle";
  LobIcon2["TPP"] = "tpp";
  LobIcon2["Umbrella"] = "umbrella";
  LobIcon2["WorkersCompensation"] = "workers-compensation";
  return LobIcon2;
})(LobIcon || {});
var LobIconMetadata = {
  ["bonds" /* Bonds */]: {
    label: "BOND",
    iconName: "Bond",
    fileIconName: "FileBond",
    classicIconName: "BondClassic",
    secondaryIconName: "SmokeBond"
  },
  ["bop" /* BOP */]: {
    label: "BOP",
    iconName: "TPPBOP",
    fileIconName: "FileTPPBOP",
    classicIconName: "TPPBOPClassic",
    secondaryIconName: "SmokeTPPBOP"
  },
  ["commercial-auto" /* CommercialAuto */]: {
    label: "CAUTO",
    iconName: "Cauto",
    fileIconName: "FileCauto",
    classicIconName: "CautoClassic",
    secondaryIconName: "SmokeCauto"
  },
  ["cpp" /* CPP */]: {
    label: "CPP",
    iconName: "TPPBOP",
    fileIconName: "FileTPPBOP",
    classicIconName: "TPPBOPClassic",
    secondaryIconName: "SmokeTPPBOP"
  },
  ["dwelling-fire" /* DwellingFire */]: {
    label: "DFIRE",
    iconName: "DwellFire",
    fileIconName: "FileDwellFire",
    classicIconName: "DwellFireClassic",
    secondaryIconName: "SmokeDwellFire"
  },
  ["executive-umbrella" /* ExecutiveUmbrella */]: {
    label: "E-UMB",
    iconName: "Umb",
    fileIconName: "FileUmb",
    classicIconName: "UmbClassic",
    secondaryIconName: "SmokeUmb"
  },
  ["farm" /* Farm */]: {
    label: "FARM",
    iconName: "Farm",
    fileIconName: "FileFarm",
    classicIconName: "FarmClassic",
    secondaryIconName: "SmokeFarm"
  },
  ["farm-umbrella" /* FarmUmbrella */]: {
    label: "F-UMB",
    iconName: "Umb",
    fileIconName: "FileUmb",
    classicIconName: "UmbClassic",
    secondaryIconName: "SmokeUmb"
  },
  ["flood" /* Flood */]: {
    label: "FLOOD",
    iconName: "Flood",
    fileIconName: "FileFlood",
    classicIconName: "FloodClassic",
    secondaryIconName: "SmokeFlood"
  },
  ["garage" /* Garage */]: {
    label: "GARAG",
    iconName: "Garage",
    fileIconName: "FileGarage",
    classicIconName: "GarageClassic",
    secondaryIconName: "SmokeGarage"
  },
  ["home" /* Home */]: {
    label: "HOME",
    iconName: "Home",
    fileIconName: "FileHome",
    classicIconName: "HomeClassic",
    secondaryIconName: "SmokeHome"
  },
  ["inland-marine" /* InlandMarine */]: {
    label: "P-IM",
    iconName: "IM",
    fileIconName: "FileIM",
    classicIconName: "IMClassic",
    secondaryIconName: "SmokeIM"
  },
  ["mobile-home" /* MobileHome */]: {
    label: "MHOME",
    iconName: "Home",
    fileIconName: "FileHome",
    classicIconName: "HomeClassic",
    secondaryIconName: "SmokeHome"
  },
  ["life" /* Life */]: {
    label: "LIFE",
    iconName: "Life",
    fileIconName: "FileLife",
    classicIconName: "LifeClassic",
    secondaryIconName: "SmokeLife"
  },
  ["personal-auto" /* PersonalAuto */]: {
    label: "PAUTO",
    iconName: "Pauto",
    fileIconName: "FilePauto",
    classicIconName: "PautoClassic",
    secondaryIconName: "SmokePauto"
  },
  ["recreational-vehicle" /* RecreationalVehicle */]: {
    label: "RV",
    iconName: "RecVeh",
    fileIconName: "FileRecVeh",
    classicIconName: "RecVehClassic",
    secondaryIconName: "SmokeRecVeh"
  },
  ["tpp" /* TPP */]: {
    label: "TPP",
    iconName: "TPPBOP",
    fileIconName: "FileTPPBOP",
    classicIconName: "TPPBOPClassic",
    secondaryIconName: "SmokeTPPBOP"
  },
  ["umbrella" /* Umbrella */]: {
    label: "UMB",
    iconName: "Umb",
    fileIconName: "FileUmb",
    classicIconName: "UmbClassic",
    secondaryIconName: "SmokeUmb"
  },
  ["workers-compensation" /* WorkersCompensation */]: {
    label: "WC",
    iconName: "WorkComp",
    fileIconName: "FileWorkComp",
    classicIconName: "WorkCompClassic",
    secondaryIconName: "SmokeWorkComp"
  }
};
function isLobIconName(name) {
  return LobIconMetadata.hasOwnProperty(name);
}
var IconBackgroundShape = /* @__PURE__ */ ((IconBackgroundShape2) => {
  IconBackgroundShape2["Circle"] = "circle";
  IconBackgroundShape2["Square"] = "square";
  IconBackgroundShape2["Octagon"] = "octagon";
  return IconBackgroundShape2;
})(IconBackgroundShape || {});

export {
  FAIcon,
  LobIcon,
  LobIconMetadata,
  isLobIconName,
  IconBackgroundShape
};
